import { AssistantCategoryTypes } from './enums/assistant-types';

export const getAIAssistantCategory = (superBlock: string) => {
  const superBlockToAssistantCategory: Record<string, AssistantCategoryTypes> =
    {
      'logica-de-programacao': AssistantCategoryTypes.ProgrammingLogic,
      'html-css-javascript': AssistantCategoryTypes.HtmlCssJs,
      react: AssistantCategoryTypes.React
    };
  return superBlockToAssistantCategory[superBlock];
};
